import React from "react";

type Props = {
  type: string;
  url: string;
};

const MessageImage: React.FC<Props> = ({ type, url }): JSX.Element => {
  return (
    <img className="rounded-md" src={url} alt={type} width={150} height={150} />
  );
};

export default MessageImage;
